module.exports = __webpack_public_path__ + "static/media/job-finder-free-no-bg.5dc41b6e.svg";